export const isValidHttpUrl = (yourUrl: string) => {
  let url;

  try {
    url = new URL(yourUrl);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}